import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import classnames from 'classnames/bind';
import { Table } from 'grab-ui';
import OrderStatus from 'components/v2/order-status/order-status';

import { getAmountDisplay, getDeliveryID } from 'helper/order';
import {
  getCreatedTimeToRender,
  getMSDRecipientName,
} from 'helper/history-order';

import css from './book-again-table.less';
import { getDisplayDeliveryType } from '../../../helper/history-order/history-order';

const cx = classnames.bind(css);

class BookAgainTable extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.columns = [
      {
        title: I18n.t('v2.orderTable.column.date'),
        key: 'date',
        render: order => getCreatedTimeToRender(order),
      },
      {
        title: I18n.t('v2.orderTable.column.sender'),
        dataIndex: 'steps',
        key: 'sender',
        render: steps => _get(steps, '[0].contact.name'),
      },
      {
        title: I18n.t('v2.orderTable.column.recipient'),
        key: 'recipient',
        render: order => getMSDRecipientName(order),
      },
      {
        title: I18n.t('v2.orderTable.column.deliveryType'),
        dataIndex: 'serviceDisplayInfo',
        key: 'serviceDisplayInfo',
        render: (_, order) => getDisplayDeliveryType(order),
      },
      {
        title: I18n.t('v2.orderTable.column.price'),
        dataIndex: 'amount',
        key: 'price',
        render: (amount, order) =>
          order &&
          order.currency &&
          getAmountDisplay(amount, order.currency, false),
      },
      {
        title: I18n.t('v2.orderTable.column.orderState'),
        key: 'status',
        render: order => <OrderStatus order={order} />,
      },
      {
        title: '',
        key: 'action',
        render: props.action,
      },
    ];
  }

  render() {
    const { orders, className, pagination, loading } = this.props;
    return (
      <Table
        columns={this.columns}
        dataSource={orders}
        className={cx('table', className, {
          'table-empty': _isEmpty(orders),
        })}
        pagination={pagination}
        loading={loading}
        rowKey={getDeliveryID}
      />
    );
  }
}

BookAgainTable.propTypes = {
  orders: PropTypes.arrayOf(PropTypes.shape({})),
  action: PropTypes.func,
  className: PropTypes.string,
  pagination: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.bool]),
  loading: PropTypes.bool.isRequired,
};

BookAgainTable.defaultProps = {
  orders: [],
  action: () => {},
  className: '',
  pagination: {},
};

export default BookAgainTable;
